/* eslint-disable react/react-in-jsx-scope */
import UserProfile from '../../../components/userProfile';

const UserProfilePage = () => {
  return (
    <div className='mx-auto mb-auto w-full max-w-7xl flex-row px-2 py-10 sm:px-6 lg:px-8'>
      <UserProfile />
    </div>
  );
};

export default UserProfilePage;
